import { render, staticRenderFns } from "./headerNav.vue?vue&type=template&id=47f07fa8&scoped=true"
import script from "./headerNav.vue?vue&type=script&lang=js"
export * from "./headerNav.vue?vue&type=script&lang=js"
import style0 from "./headerNav.vue?vue&type=style&index=0&id=47f07fa8&prod&scoped=true&lang=scss"
import style1 from "./headerNav.vue?vue&type=style&index=1&id=47f07fa8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f07fa8",
  null
  
)

export default component.exports